import React from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader";

const LoadingIndicator = () => {
  const {
    getCountriesLoader,
    getStatesByCountryLoader,
    getCitiesByStateLoader,
    getSpecialitiesLoader,
  } = useSelector((state) => state.formField);

  const { searchProvidersLoader } = useSelector(
    (state) => state.searchProviders
  );

  const isLoaderVisible =
    getCountriesLoader ||
    getStatesByCountryLoader ||
    getCitiesByStateLoader ||
    getSpecialitiesLoader ||
    searchProvidersLoader;

  return <Loader isLoaderVisible={isLoaderVisible} />;
};

export default LoadingIndicator;
